var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheEssentialFacial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.4844,
    r: 24,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2388 26.3776C23.501 27.4774 22.389 26.3032 23.2632 23.9447C24.1373 21.5862 24.2378 16.0741 22.7239 13.5836C21.7325 11.9493 17.2746 11.3199 14.3339 11.083C12.7698 10.9544 11.1856 10.792 11.0583 12.3689C10.0167 25.2948 14.756 37.27 25.8153 39.0059C25.8153 39.0059 30.6082 39.0059 34.2589 33.1113",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 16.6836C15.3961 18.9507 19.2679 19.218 21.1569 17.8848",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8223 17.3912C29.3495 19.7328 33.6299 19.2997 35.673 17.0156",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1562 30.0546C21.1562 30.0546 22.3252 32.2912 25.5807 32.2675C28.2902 32.2472 30.0185 30.041 30.0185 30.041",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheEssentialFacial);
export default __webpack_public_path__ + "static/media/the-essential-facial.a3bbed86d3ea8b87a6c46b7fd1c7ba1e.svg";
export { ForwardRef as ReactComponent };